import type { AssetTypeCreateDto, AssetTypeDto, AssetTypeUpdateDto, GetAssetTypesInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AssetTypeService {
  apiName = 'Inventory';

  create = (input: AssetTypeCreateDto) =>
    this.restService.request<any, AssetTypeDto>({
      method: 'POST',
      url: '/api/inventory/asset-types',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/asset-types/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, AssetTypeDto>({
      method: 'GET',
      url: `/api/inventory/asset-types/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetAssetTypesInput) =>
    this.restService.request<any, PagedResultDto<AssetTypeDto>>({
      method: 'GET',
      url: '/api/inventory/asset-types',
      params: { filterText: input.filterText, name: input.name, description: input.description, code: input.code, image: input.image, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: AssetTypeUpdateDto) =>
    this.restService.request<any, AssetTypeDto>({
      method: 'PUT',
      url: `/api/inventory/asset-types/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
